<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<h4>SPKLU REPORT</h4>
			</div>
			<div class="col-md-12">
				<el-card shadow="never" class="box-card col-md-12 mb-4">
                    <div slot="header" class="clearfix" v-if="false">
                        <strong><span>SPKLU Report</span></strong>
                    </div>
                    <div style="margin-top:0px;">
						<div class="row">
							<div class="col-md-12 px-0">
								<el-tabs v-model="activeName" @tab-click="handleClick">
									<el-tab-pane name="station">
										<span slot="label">Station</span>
										<div class="px-0 tab-container-item">
											<SPKLUReportMonitoringMachine :tabIndex="0" :tabName="'station'" :tabLabel="'Station'"/>
										</div>
									</el-tab-pane>
									<el-tab-pane label="Charge Box" name="chargebox">
										<span slot="label">Charge Box</span>
										<div class="px-0 tab-container-item">
											<SPKLUReportMonitoringMachine :tabIndex="0" :tabName="'charge-box'" :tabLabel="'Charge Box'"/>
										</div>
									</el-tab-pane>
									<el-tab-pane label="Socket" name="socket">
										<span slot="label">Socket</span>
										<div class="px-0 tab-container-item">
											<SPKLUReportMonitoringMachine :tabIndex="0" :tabName="'socket'" :tabLabel="'socket'"/>
										</div>
									</el-tab-pane>
								</el-tabs>
							</div>
						</div>
                    </div>
                </el-card>
			</div>
		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Config,Penanggalan,AxiosWithJar, FuelColor, Rainbow, Rainbow2 } from '@/utility.js'
import $ from 'jquery';

import SPKLUReportMonitoringMachine from '@/views/pages/SPKLU/Component/SPKLUReportMonitoringMachine.vue'

export default{
	extends: Fuel,
	components:{
		SPKLUReportMonitoringMachine,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	data(){
		return {
            value: 0,
			activeName: this.$route.query.tab ? this.$route.query.tab : 'station',

			outterheight: 160,
			screenHeight: window.innerHeight - 300,
		}
	},
	watch: {

	}, 
	computed:{

	},

    mounted(){
		this.$emit('childrenRoute');
		//window.addEventListener('resize', this.setDivHeight);
		$(".el-tabs__header").addClass("m-0");
    },
    methods:{
		setDivHeight() {
          this.screenHeight = window.innerHeight - this.outterheight;
        },
		addTabNavClass() {
			$(".el-tabs__nav-wrap").addClass("bg-white");
			$(".el-tabs__header").addClass("tab-nav");	
		},
		handleClick(tab, event) {
			console.log(tab, event);
		}
	}
}
</script>